module.exports = {"TXTCLI_Tabs":{"id":"TXTCLI_Tabs","defaultMessage":"Ετικέτες"}}